module.exports = __webpack_public_path__ + "img/ic_amenity.fdaf7976.svg";